// extracted by mini-css-extract-plugin
export var callCard = "_oj-0";
export var callMessageButton = "_oj-1";
export var helpIcon = "_oj-3";
export var helpIconContainer = "_oj-4";
export var verticalDivider = "_oj-2";